/**
 * @file launcher-view.ts
 * @description Подписи кнопки «Сообщения» и подсказки над ней
 * (chat-window-design.md §1а, §7): число «99+», первая строка подсказки по
 * виду события, время показа подсказки.
 */

import { CHAT_TEXT } from "./chat-texts";
import type { ChatHint } from "./useChatSummary";

/** Подсказка исчезает через 6 с (пауза при наведении и фокусе). */
export const HINT_TIMEOUT_MS = 6_000;

/** Счётчик на кнопке: больше 99 — «99+». */
export function launcherCount(n: number): string | null {
  if (n <= 0) return null;
  return n > 99 ? "99+" : String(n);
}

/** Первая строка подсказки по виду события. */
export function hintTitle(hint: Pick<ChatHint, "kind" | "orderNumber" | "actorName">): string {
  const ctx = hint.orderNumber ? CHAT_TEXT.order(hint.orderNumber) : CHAT_TEXT.generalChat;
  if (hint.kind === "TRANSFERRED_TO_ME") return CHAT_TEXT.hintTransferred(hint.actorName);
  if (hint.kind === "UNARCHIVED") return CHAT_TEXT.hintUnarchived(ctx);
  return CHAT_TEXT.hintMessage(ctx);
}

